<template>
  <article class="notice-wrapper">
    <div class="container">
      <p class="main-title">공지사항</p>

      <table>
        <thead>
          <tr>
            <th>번호</th>
            <th>제목</th>
            <th>작성일자</th>
            <th>조회수</th>
          </tr>
        </thead>
        <template v-if="compNotictTable.length > 0">
          <tbody>
            <tr
              v-for="(item, index) in compNotictTable"
              :key="index"
              :class="item.contentsTypeName === '전체공지' ? 'notice' : ''"
              @click="moveDetail(item.idx)"
            >
              <td class="name">
                {{
                  item.contentsTypeName === "전체공지" ? "공지" : item.rowNum
                }}
              </td>
              <td class="title">{{ item.title }}</td>
              <td>{{ item.createDate }}</td>
              <td>{{ item.viewCnt }}</td>
            </tr>
          </tbody>
        </template>
        <tbody v-else>
          <tr>
            <td colspan="99">등록된 공지사항이 없습니다.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </article>
  <!-- <Banner :imgname="'banner-white'" :bgcolor="'white'"></Banner> -->
</template>

<script>
import { computed, onMounted, ref } from "@vue/runtime-core";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { noticeList } from "@/api/integratedapi/index";
export default {
  props: {
    /* 게시판 타이틀 */
    boardTitle: {
      type: String,
      required: false,
      default: "",
    },
    /* 게시판 내용 */
    boardContents: {
      type: String,
      required: false,
      default: "",
    },
    /* More 사용여부 */
    isUseMore: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const totalCount = ref(0);
    const noticeListTable = ref([]);
    const noticeSearch = ref({
      pageNum: 1,
      pageSize: 50,
    });    
    const apiNoticeList = async (code) => {
      await noticeList(code, noticeSearch.value)
        .then((res) => {
          const { data: respData } = res.data;
          const { list, total } = respData;
          noticeListTable.value = list;
          totalCount.value = total;
        })
        .catch(function (error) {
          noticeListTable.value = [];
          totalCount.value = 0;
          if (error.response) {
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    };    
    const moreRouter = () => {
      router.push(`/notice/${store.getters.getCompanyInfo["code"]}`);
    };

    const compNotictTable = computed(() => {
      const copyNoticeTable = _.cloneDeep(noticeListTable.value);

      for (let i = 0; i < copyNoticeTable.length; i++) {
        copyNoticeTable[i]["createDate"] =
          copyNoticeTable[i]["createDate"].split(" ")[0];
      }

      return copyNoticeTable;
    });
    const moveDetail = (noticeDetailIdx) => {
      router.push(`/notice/detail/${noticeDetailIdx}`);
    };

    onMounted(async () => {
      await apiNoticeList(store.getters.getCompanyInfo.code);
    });

    return {
      moreRouter,
      compNotictTable,
      noticeListTable,
      moveDetail
    };
  },
};
</script>
<style lang="scss" scoped>
.notice-wrapper {
  padding: 98px 0 116px;

  .main-title {
    font-size: 44px;
    font-weight: $bold;
    text-align: center;
    margin-bottom: 90px;
  }

  table {
    width: 100%;
    margin-bottom: 52px;

    thead {
      border-top: 2px solid $black;
    }

    th {
      font-size: 18px;
      font-weight: $medium;
      padding: 22.5px 0;
      background-color: $gray-dde0e4;
    }

    td {
      padding: 21.5px 0;
      text-align: center;
    }

    tbody {
      tr {
        font-size: 15px;
        cursor: pointer;
        border-bottom: 2px solid rgba($color: $black, $alpha: 0.1);

        .title {
          text-align: left;
        }

        &.notice {
          font-weight: $medium;
          background-color: #edf4ff;

          .name {
            color: $blue;
          }
        }
      }
    }
  }

  .pagination-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0 33px;

    li {
      font-size: 13px;
      cursor: pointer;

      &.num {
        padding-bottom: 5px;
        height: 23px;
        border-bottom: 1px solid transparent;
      }

      &.on {
        border-bottom: 1px solid $black;
      }

      .pagi-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border: 1px solid #676767;
        border-radius: 6px;
      }
    }
  }
}
</style>
